var _a;
import { pxToRem } from '../utils/utils';
import { breakpoints } from './breakpoints';
export var spacings = {
    spacingResponsiveMap: (_a = {},
        _a[breakpoints.mobile] = {
            xxsmall: pxToRem('4px'),
            xsmall: pxToRem('8px'),
            small: pxToRem('12px'),
            medium: pxToRem('16px'),
            large: pxToRem('24px'),
            xlarge: pxToRem('32px'),
            xxlarge: pxToRem('40px'),
        },
        _a[breakpoints.tablet] = {
            xxsmall: pxToRem('8px'),
            xsmall: pxToRem('12px'),
            small: pxToRem('16px'),
            medium: pxToRem('24px'),
            large: pxToRem('32px'),
            xlarge: pxToRem('40px'),
            xxlarge: pxToRem('56px'),
        },
        _a[breakpoints.laptop] = {
            xxsmall: pxToRem('12px'),
            xsmall: pxToRem('16px'),
            small: pxToRem('24px'),
            medium: pxToRem('32px'),
            large: pxToRem('40px'),
            xlarge: pxToRem('56px'),
            xxlarge: pxToRem('72px'),
        },
        _a[breakpoints.desktop] = {
            xxsmall: pxToRem('16px'),
            xsmall: pxToRem('20px'),
            small: pxToRem('28px'),
            medium: pxToRem('36px'),
            large: pxToRem('48px'),
            xlarge: pxToRem('64px'),
            xxlarge: pxToRem('88px'),
        },
        _a),
    spacingStaticMap: {
        xxsmall: pxToRem('4px'),
        xsmall: pxToRem('8px'),
        small: pxToRem('12px'),
        medium: pxToRem('16px'),
        large: pxToRem('24px'),
        xlarge: pxToRem('32px'),
        xxlarge: pxToRem('40px'),
    },
};
